// removed by extract-text-webpack-plugin
module.exports = {"videoLoop":"dh-video-videoLoop","videoLoop__maxHeightWrapper":"dh-video-videoLoop__maxHeightWrapper","videoLoop__sizeWrapper":"dh-video-videoLoop__sizeWrapper","videoLoop__innerMaxHeightWrapper":"dh-video-videoLoop__innerMaxHeightWrapper","videoLoop__fallbackImage":"dh-video-videoLoop__fallbackImage","videoLoop--showFallbackImage":"dh-video-videoLoop--showFallbackImage","videoLoop__videoElement":"dh-video-videoLoop__videoElement","videoLoop__textWrapper":"dh-video-videoLoop__textWrapper","videoLoop__title":"dh-video-videoLoop__title","videoLoop__leadText":"dh-video-videoLoop__leadText"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/kurator/components/VideoLoop.css
// module id = 16
// module chunks = 2